var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutubeFooter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1.339,
    y1: 0.5,
    x2: 3.833,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3decd3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28348b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_215",
    "data-name": "Groupe 215",
    transform: "translate(-246.628 -1591.147)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_39",
    "data-name": "Ellipse 39",
    cx: 15.5,
    cy: 15,
    rx: 15.5,
    ry: 15,
    transform: "translate(246.628 1591.147)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "youtube",
    d: "M14.621-4.447A1.87,1.87,0,0,0,13.3-5.762a43.693,43.693,0,0,0-5.841-.32,45.4,45.4,0,0,0-5.84.307A1.908,1.908,0,0,0,.308-4.447,19.7,19.7,0,0,0,0-.856a19.633,19.633,0,0,0,.307,3.59A1.87,1.87,0,0,0,1.624,4.05a43.772,43.772,0,0,0,5.841.32,45.4,45.4,0,0,0,5.84-.307,1.87,1.87,0,0,0,1.316-1.316,19.712,19.712,0,0,0,.307-3.59,18.7,18.7,0,0,0-.307-3.6ZM5.977,1.382V-3.094L9.862-.856Zm0,0",
    transform: "translate(254.871 1606.925)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeFooter);
export default __webpack_public_path__ + "static/media/Youtube_footer.2d8422e262950647e2ba47a9639fd240.svg";
export { ForwardRef as ReactComponent };